import { Injectable } from '@angular/core';
import io, { Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class QueueSocketService {
  private socket: Socket;

  constructor() {}

  public onEvent(eventName: string): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (val: any) => {
        subscriber.next(val);
      });
    });
  }

  public clearListener() {
    this.socket.off();
  }

  public initSocket() {
    const socketURL = new URL(`${environment.urlQueue}`);

    this.socket = io(socketURL.origin, {
      upgrade: true,
      path: '/socket.io',
      transports: ['websocket'],
      autoConnect: true,
    });

    // this.socket.on('connect', () => {
    //   console.log('queue connected');
    // });
  }

  public reconnect(): void {
    if (this.socket?.connected) {
      this.socket.disconnect();
    }
    this.initSocket();
  }
}
